import clsx from 'clsx'
import { NumberParam, StringParam, useQueryParams } from 'use-query-params'

import { Tooltip } from '@pepper/ui'

import { DomainRefresh } from '../../types'
import s from './QuickFilters.module.css'

type Props = {
  stats: DomainRefresh
}

export const QuickFilters = ({ stats }: Props) => {
  const [query, setQuery] = useQueryParams({
    type: StringParam,
    page: NumberParam,
  })

  return (
    <div className={s.wrapper}>
      <button
        className={clsx(s.button, { [s.isActive]: !query.type })}
        onClick={() => setQuery({ type: undefined, page: undefined })}
      >
        All ({stats.refresh_opportunities + stats.quick_wins})
      </button>

      <Tooltip title="Revamp and re-engage with declining traffic pages">
        <button
          className={clsx(s.button, s.refreshOpBtn, {
            [s.isActive]: query.type === 'refresh_opportunity',
          })}
          onClick={() =>
            setQuery({ type: 'refresh_opportunity', page: undefined })
          }
        >
          Refresh Opportunities ({stats.refresh_opportunities})
        </button>
      </Tooltip>

      <Tooltip title="Top-ranking pages with untapped traffic potential">
        <button
          className={clsx(s.button, s.quickWinsBtn, {
            [s.isActive]: query.type === 'quick_win',
          })}
          onClick={() => setQuery({ type: 'quick_win', page: undefined })}
        >
          Quick Wins ({stats.quick_wins})
        </button>
      </Tooltip>
    </div>
  )
}
